/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Form_Guest_PInputs */

const es_cap_form_guest_p = /** @type {(inputs: Cap_Form_Guest_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu perfil y empieza a recibir propuestas de salida en tu zona. Sin cuotas: solo ganamos cuando tú ganas.`)
};

const gl_cap_form_guest_p = /** @type {(inputs: Cap_Form_Guest_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea o teu perfil e comeza a recibir propostas de saída na túa zona. Sen cotas: só gañamos cando ti gañas.`)
};

const en_cap_form_guest_p = /** @type {(inputs: Cap_Form_Guest_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your profile and start receiving trip proposals in your area. No fees — we only earn when you do.`)
};

/**
* | output |
* | --- |
* | "Create your profile and start receiving trip proposals in your area. No fees — we only earn when you do." |
*
* @param {Cap_Form_Guest_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_form_guest_p = /** @type {((inputs?: Cap_Form_Guest_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Form_Guest_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_form_guest_p(inputs)
	if (locale === "en") return en_cap_form_guest_p(inputs)
	return es_cap_form_guest_p(inputs)
});